export default __webpack_public_path__ + "static/media/pravidla.56a6360e.pdf";